import { useAuthStore } from '@/store/authStore';

export function usePermission(code: string): boolean {
  const user = useAuthStore((state) => state.user);
  if (!user) return false;
  if (user.role?.is_system) return true;
  const perms = user.permissions ?? [];
  if (perms.includes('*')) return true;
  return perms.includes(code);
}

export function useAnyPermission(...codes: string[]): boolean {
  const user = useAuthStore((state) => state.user);
  if (!user) return false;
  if (user.role?.is_system) return true;
  const perms = user.permissions ?? [];
  if (perms.includes('*')) return true;
  return codes.some((code) => perms.includes(code));
}

export function useIsAdmin(): boolean {
  const user = useAuthStore((state) => state.user);
  return user?.role?.is_system === true;
}
